import { useEffect } from 'react'
import React from 'react'
import { adjustFrameHeight } from '../utils'
import { Stack, Typography } from '@elsevier/eds-core'
import { EmptyState, Table, THeaderCell, TRow } from '@elsevier/graphene'
import JobListing from './JobListing'

interface jobData {
  id: string
  attributes: {
    links: any
    requestDateTime: number
    fileName: string
    status: string
  }
}

interface jobsDataListProp {
  pastJobsData: jobData[]
  showEmptyState: boolean
}
/*
 */

export default function ContentInventoryJobsList({
  pastJobsData,
  showEmptyState,
}: jobsDataListProp) {
  // Adjust frame height
  useEffect(() => {
    adjustFrameHeight()
  }, [pastJobsData, showEmptyState])

  return (
    <Stack spacing="28dp">
      <Typography as="h3" fontSize="heading-x_small" fontWeight={700}>
        Content inventory jobs
      </Typography>
      <Typography as="p" fontSize="body-medium">
        Jobs are deleted 30 days after request.
      </Typography>
      {showEmptyState ? (
        <EmptyState
          data-feature="content-inventory-empty-state"
          variant="empty"
          title="No content inventory jobs"
          titleAs="h4"
          description="No jobs were run in the last 30 days."
        />
      ) : (
        <Table
          data-feature="content-inventory-jobs-table"
          caption="Content inventory jobs"
          hideCaption
        >
          <thead>
            <TRow>
              <THeaderCell>File name</THeaderCell>
              <THeaderCell>Request Date</THeaderCell>
              <THeaderCell>Status</THeaderCell>
            </TRow>
          </thead>
          <tbody>
            {pastJobsData.map((job: jobData) => {
              const { requestDateTime, fileName, status } = job.attributes
              const jobId = job.id
              const jobUrl = job.attributes.links.results

              return (
                <JobListing
                  key={jobId}
                  fileName={fileName}
                  status={status}
                  requestDateTime={requestDateTime}
                  jobUrl={jobUrl}
                />
              )
            })}
          </tbody>
        </Table>
      )}
    </Stack>
  )
}
